<template>
  <div>
    <div class="row justify-content-between">
      <b-form-group
        class="col-sm-6 col-md-4 mr-1"
        :label="$t('Select User')"
      >
        <user-search
          v-model="form.userId"
          class="card"
          :placeholder="$t('All Users')"
          :multiple="true"
        />
      </b-form-group>

      <b-form-group class="col-sm-6 col-md-4 mr-1">
        <date-range-filter
          :till-day-before="true"
          @change="dateChange"
        />
      </b-form-group>
    </div>

    <payment-table :form="form" />
  </div>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue'
import UserSearch from '@/views/common/components/UserSearch.vue'
import DateRangeFilter from '@/views/common/components/DateRangeFilter.vue'
import PaymentTable from './components/Table.vue'

const moment = require('moment')

export default {
  components: {
    PaymentTable,
    BFormGroup,
    UserSearch,
    DateRangeFilter,
  },
  data() {
    return {
      form: {
        start_date: moment(this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_date: this.maxDate(),
        userId: null,
      },
      isProcessing: false,
      usingCustomDateRange: false,
    }
  },
  methods: {
    maxDate() {
      return this.SUBTRACT_DAYS(this.TODAY_COMPANY_TIME(), 1).start
    },
    dateChange(range) {
      if (!range.startTime && !range.endTime) {
        this.usingCustomDateRange = true
        return null
      }
      this.form.start_date = range.startTime
      this.form.end_date = range.endTime
      this.usingCustomDateRange = false
      return null
    },
  },
}
</script>
<style lang="scss">
.blurry-text {
  color: transparent !important;
  text-shadow: 0 0 7px rgba(0, 0, 0, 0.6); /* Use rgba for better transparency control */
}
.dark-layout {
  .blurry-text {
    text-shadow: 0 0 7px rgba(255, 255, 255, 0.6);
  }
}
</style>
